exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-0fac44a0]{display:inline-block;margin-bottom:20px;font-size:17px;font-weight:700}.explanation[data-v-0fac44a0]{width:420px;display:block;margin:25px auto 10px;text-align:center}", ""]);

// exports
